import React from 'react';
import { Check } from 'lucide-react';

export interface WorkflowStep {
  id: string;
  label: string;
  shortLabel: string;
  isComplete: boolean;
  isAccessible: boolean;
}

interface WorkflowStepperProps {
  steps: WorkflowStep[];
  activeStepId: string;
  onStepClick: (stepId: string) => void;
}

export const WorkflowStepper: React.FC<WorkflowStepperProps> = ({
  steps,
  activeStepId,
  onStepClick,
}) => {
  return (
    <div className='flex items-center border-b border-gray-200'>
      <div className='flex items-center overflow-x-auto scrollbar-hide'>
        {steps.map((step, index) => {
          const isActive = step.id === activeStepId;
          const isComplete = step.isComplete;

          return (
            <button
              key={step.id}
              onClick={() => step.isAccessible && onStepClick(step.id)}
              disabled={!step.isAccessible}
              className={`
                relative flex items-center gap-2 px-4 py-2.5 text-sm font-medium
                transition-all duration-150 whitespace-nowrap border-b-2 -mb-px
                ${
                  isActive
                    ? 'border-gray-900 text-gray-900'
                    : isComplete
                      ? 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                      : step.isAccessible
                        ? 'border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-200'
                        : 'border-transparent text-gray-300 cursor-not-allowed'
                }
              `}
            >
              {/* Step number or check */}
              <span
                className={`
                flex items-center justify-center w-5 h-5 rounded-full text-xs font-semibold
                ${
                  isComplete
                    ? 'bg-emerald-500 text-white'
                    : isActive
                      ? 'bg-gray-900 text-white'
                      : step.isAccessible
                        ? 'bg-gray-200 text-gray-600'
                        : 'bg-gray-100 text-gray-300'
                }
              `}
              >
                {isComplete ? (
                  <Check className='w-3 h-3' strokeWidth={3} />
                ) : (
                  index + 1
                )}
              </span>
              {step.shortLabel}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WorkflowStepper;
